import merge from 'lodash/merge';
import { i18nString } from 'typesafe-i18n';
import { defaultTranslations } from '@/modules/common';

export type Locale = keyof typeof defaultTranslations;

export const initI18N = (locale: Locale) => {
  // Custom i18nString formatters
  const formatters = {};
  // Initialize i18nString with locale and formatters
  const LLL = i18nString(locale, formatters);
  window.LLL = (...args: Parameters<ReturnType<typeof i18nString>>) => {
    if (!args?.[0]) {
      return '';
    }
    return LLL(...args);
  };
};

export async function loadTranslations(locale: string, tenant: string, shouldFetch: boolean) {
  try {
    initI18N(locale as Locale);
    const currentDate = new Date().toISOString();
    let translations: Record<string, string> = {};
    if (shouldFetch) {
      let response = await fetch(
        `https://storage.googleapis.com/saywhatt-chat/translations/${tenant}/${locale}.json?v=${currentDate}`
      );
      if (response.status === 404 && locale !== 'en') {
        // selected translation not found, try to load en
        response = await fetch(
          `https://storage.googleapis.com/saywhatt-chat/translations/${tenant}/en.json?v=${currentDate}`
        );
      }
      if (!response.ok) {
        return {
          error: `Failed to load translations for locale ${locale}: ${response.statusText}`,
          translations: defaultTranslations[locale as Locale] ?? defaultTranslations['en'],
        };
      }
      translations = await response.json();
    }

    const currentDefaultTranslations = defaultTranslations[locale as Locale] ?? defaultTranslations['en'];

    return {
      translations: merge({}, currentDefaultTranslations, translations, {
        variants: currentDefaultTranslations.variants,
      }),
    };
  } catch (error) {
    console.error('Error loading translations:', error);
    return {
      error: `Error loading translations for locale ${locale}: ${error instanceof Error ? error.message : 'Unknown error'}`,
      translations: defaultTranslations[locale as Locale] ?? defaultTranslations['en'],
    };
  }
}
